export enum KeyObjectBulkUpload {
  firstName = 'First Name',
  lastName = 'Last Name',
  email = 'Email',
  birthDate = 'Birth Date',
  gender = 'Gender',
  heightFT = 'Height FT',
  heightIN = 'Height IN',
  weight = 'Weight',
  throwingArm = 'Throwing Arm',
  bats = 'Bats',
  PrimaryPosition = 'Primary Position',
  SecondaryPosition = 'Secondary Position',
  playingLevel = 'Playing Level',
  country = 'Country',
  stateOrProvidence = 'State or Providence',
  season = 'Season',
}
